import { render, staticRenderFns } from "./subPartner.vue?vue&type=template&id=183ce9b6"
import script from "./subPartner.vue?vue&type=script&lang=js"
export * from "./subPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports